import React, { CSSProperties } from 'react';
import SideNavContent from './sideNavContent';

export type layoutSideNavType = {
  sidebarStyle: CSSProperties;
  logoStyle: CSSProperties;
  logoSrc: string;
  isCollapsed: boolean;
};

const LayoutSideNav: React.FC<layoutSideNavType> = ({
  sidebarStyle,
  logoSrc,
  logoStyle,
  isCollapsed,
}) => {
  return (
    <div
      className="fixed top-0 left-0 flex flex-col h-screen px-4 py-2 bg-white transition-all duration-300"
      style={{ ...sidebarStyle, zIndex: 50 }}
    >
      {/* Logo — always pinned at the top, never scrolls */}
      <div className="flex items-center justify-between w-full px-4 shrink-0">
        <img
          src={logoSrc}
          alt="pozytron logo"
          className="shrink-0 transition-transform duration-500 ease-in-out"
          style={logoStyle}
        />
      </div>

      {/* Nav items — the only scrollable region; grows to fill the space left
          over by the logo and illustration, so a scrollbar only appears when
          the nav items themselves don't fit that space. */}
      <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden overscroll-contain mt-[37px]">
        <SideNavContent isIconOnly={isCollapsed} />
      </div>

      {/* Illustration — always pinned at the bottom, its height is always
          reserved so it never gets squeezed by the nav list above. */}
      {!isCollapsed && (
        <img
          src="/navBarIllastration.svg"
          alt="pozytron logo"
          className="shrink-0"
        />
      )}
    </div>
  );
};

export default LayoutSideNav;
